export const environment = {
  production: true,
  env: "qa", //TODO,
  loggerSw: true,
  storeDevtoolsSw: true,
};
